export default __webpack_public_path__ + "static/media/brainferg2.5dbadf93.jpg";